import React from 'react';
import {motion} from 'framer-motion'
import { fadeIn } from '../../constants/variants';
import { images } from '../../constants';
import './AboutUs.css';

const AboutUs = () => (
  <div className="app__aboutus app__bg flex__center section__padding" id="about">
    <motion.div 
    variants={fadeIn('up')}
    initial='hidden'
    whileInView={'show'}
    viewport={{ once: false, amount: 0.6 }}
      className="app__aboutus-overlay flex__center">
      <img src={images.G} alt="G_overlay" />
    </motion.div>

    <div className="app__aboutus-content flex__center">
      <motion.div 
        variants={fadeIn('right')}
        initial='hidden'
        whileInView={'show'}
        viewport={{ once: false, amount: 0.6 }}
        className="app__aboutus-content_about">
        <h1 className="headtext__cormorant">About Us</h1>
        <img src={images.spoon} alt="about_spoon" className="spoon__img" />
        <p className="p__opensans">Come with us as we take a big bite of all the top restaurants in Johannesburg. From African to Italian and everything else in between, let’s make your culinary dreams come true.</p>
        <button type="button" className="custom__button">Know More</button>
      </motion.div>

      <motion.div 
        variants={fadeIn('up')}
        initial='hidden'
        whileInView={'show'}
        viewport={{ once: false, amount: 0.6 }}
        className="app__aboutus-content_knife flex__center">
        <img src={images.knife} alt="about_knife" />
      </motion.div>

      <motion.div 
        variants={fadeIn('left')}
        initial='hidden'
        whileInView={'show'}
        viewport={{ once: false, amount: 0.6 }}
        className="app__aboutus-content_history">
        <h1 className="headtext__cormorant">Our History</h1>
        <img src={images.spoon} alt="about_spoon" className="spoon__img" />
        <p className="p__opensans">What is the history of restaurants?
The term 'restaurant' first appeared in the 18th century in France. It referred to a reinvigorating meat broth which people ate to refortify the body.</p>
        <button type="button" className="custom__button">Know More</button>
      </motion.div>
    </div>
  </div>
);

export default AboutUs;
